"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertCollapsible = void 0;
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
var icons_1 = require("@ant-design/icons");
var TRANSITION_TIME = 200;
var StyledAlert = styled_components_1.default(antd_1.Alert)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 8px 16px;\n\n  @keyframes open {\n    0% {\n      z-index: auto;\n      user-select: auto;\n      height: 0px;\n      position: unset;\n      opacity: 0;\n    }\n    30% {\n      opacity: 0;\n    }\n    99% {\n      opacity: 0;\n      height: ", "px;\n    }\n    100% {\n      opacity: 1;\n      height: auto;\n    }\n  }\n  @keyframes close {\n    0% {\n      height: ", "px;\n      opacity: 0;\n    }\n    30% {\n      opacity: 0;\n    }\n    99% {\n      height: 0px;\n      opacity: 0;\n    }\n    100% {\n      z-index: -999;\n      user-select: none;\n      height: auto;\n      position: absolute;\n      opacity: 0;\n    }\n  }\n  &&& {\n    .ant-alert-message {\n      margin-bottom: ", "px;\n      transition: all ", "ms ease-in-out;\n      font-size: 14px;\n      margin-top: 1px;\n    }\n    .ant-alert-description {\n      animation: ", " 200ms linear;\n      animation-fill-mode: forwards;\n    }\n\n    .ant-alert-icon {\n      font-size: 18px;\n      margin-top: 3px;\n    }\n  }\n"], ["\n  padding: 8px 16px;\n\n  @keyframes open {\n    0% {\n      z-index: auto;\n      user-select: auto;\n      height: 0px;\n      position: unset;\n      opacity: 0;\n    }\n    30% {\n      opacity: 0;\n    }\n    99% {\n      opacity: 0;\n      height: ", "px;\n    }\n    100% {\n      opacity: 1;\n      height: auto;\n    }\n  }\n  @keyframes close {\n    0% {\n      height: ", "px;\n      opacity: 0;\n    }\n    30% {\n      opacity: 0;\n    }\n    99% {\n      height: 0px;\n      opacity: 0;\n    }\n    100% {\n      z-index: -999;\n      user-select: none;\n      height: auto;\n      position: absolute;\n      opacity: 0;\n    }\n  }\n  &&& {\n    .ant-alert-message {\n      margin-bottom: ", "px;\n      transition: all ", "ms ease-in-out;\n      font-size: 14px;\n      margin-top: 1px;\n    }\n    .ant-alert-description {\n      animation: ", " 200ms linear;\n      animation-fill-mode: forwards;\n    }\n\n    .ant-alert-icon {\n      font-size: 18px;\n      margin-top: 3px;\n    }\n  }\n"])), function (_a) {
    var $descriptionHeight = _a.$descriptionHeight;
    return $descriptionHeight;
}, function (_a) {
    var $descriptionHeight = _a.$descriptionHeight;
    return $descriptionHeight;
}, function (_a) {
    var $open = _a.$open;
    return ($open ? 4 : 0);
}, TRANSITION_TIME, function (_a) {
    var $open = _a.$open;
    return ($open ? "open" : "close");
});
var AlertCollapsible = function (_a) {
    var action = _a.action, _b = _a.collapsible, collapsible = _b === void 0 ? true : _b, description = _a.description, _c = _a.destroyOnClose, destroyOnClose = _c === void 0 ? false : _c, props = __rest(_a, ["action", "collapsible", "description", "destroyOnClose"]);
    var ref = react_1.useRef();
    var _d = react_1.useState(!collapsible), open = _d[0], setOpen = _d[1];
    /** Tracks if the content is openeded once. */
    var _e = react_1.useState(false), opended = _e[0], setOpened = _e[1];
    var _f = react_1.useState(0), descriptionHeight = _f[0], setDescriptionHeight = _f[1];
    var getDescriptionHeight = function () {
        if (ref.current) {
            var node = ref.current.querySelector(".ant-alert-description");
            return (node === null || node === void 0 ? void 0 : node.clientHeight) || 0;
        }
        return 0;
    };
    var toggle = react_1.useCallback(function () {
        setOpen(function (p) { return !p; });
        /** getting description height */
        setDescriptionHeight(getDescriptionHeight());
    }, []);
    react_1.useEffect(function () {
        if (opended) {
            toggle();
        }
    }, [opended, toggle]);
    react_1.useEffect(function () {
        if (destroyOnClose && !open) {
            setOpened(false);
        }
    }, [open, destroyOnClose]);
    return (react_1.default.createElement("div", { ref: ref },
        react_1.default.createElement(StyledAlert, __assign({ "$descriptionHeight": descriptionHeight, "$open": open, action: react_1.default.createElement(react_1.default.Fragment, null,
                action,
                collapsible && (react_1.default.createElement(antd_1.Button, { type: "text", size: "small", icon: open ? react_1.default.createElement(icons_1.UpOutlined, null) : react_1.default.createElement(icons_1.DownOutlined, null), onClick: function () {
                        if (opended) {
                            toggle();
                        }
                        else {
                            setOpened(true);
                        }
                    } }))), description: opended ? description : react_1.default.createElement(react_1.default.Fragment, null) }, props))));
};
exports.AlertCollapsible = AlertCollapsible;
var templateObject_1;
